import { Navigate, Outlet } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';
import { LoadingLayout } from '@/layouts/LoadingLayout';

import { useWorkspace } from './WorkspaceProvider';

/**
 * Route-level gate for `/company/*` — access is derived from MEMBERSHIP (an ACTIVE `CompanyUser`)
 * or a company registration in flight, never from the `Company` platform role (Stage 1 decision:
 * "gate on membership, not role"). A pending founder reaches their approval/bootstrap experience;
 * an account with no company journey at all is sent to the onboarding chooser — never a 403 or a
 * blank page.
 */
export function CompanyGuard() {
  const { loading, hasCompanyAccess } = useWorkspace();

  if (loading) return <LoadingLayout />;

  if (!hasCompanyAccess) {
    return <Navigate to={ROUTES.welcome} replace />;
  }

  return <Outlet />;
}
